import {Col, Row} from 'reactstrap';
const Colxx = (props) => (
	<Col {...props} widths={['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']} />
);
export {Colxx, Row}